import {html, HTMLTemplateResult} from "lit";
import {customElement} from "lit/decorators/custom-element.js";
import {AbstractTileComponent} from "./abstract-tile.component";
import type {ExternalLinkTarget} from "../../../domain/entities/link-targets/external-link-target";

/** A Linkview tile linking to an external URL — `target.url` already
 *  normalized/scheme-guarded by `LinkTileHelper.normalizeUrl()` (see
 *  `LinkTileHelper.createTile`/`applyDraft`) by the time it reaches here. */
@customElement('link-tile-external')
export class LinkTileExternalComponent extends AbstractTileComponent<ExternalLinkTarget> {

    protected override _renderBody(): HTMLTemplateResult {
        return html`
            <a class="dashboard-tile__link" href=${this.target.url} target="_blank" rel="noopener noreferrer">
                ${this._renderIconAndText()}
            </a>
        `;
    }

}
